import { render, staticRenderFns } from "./gysHome.vue?vue&type=template&id=adf53162&scoped=true&"
import script from "./gysHome.vue?vue&type=script&lang=js&"
export * from "./gysHome.vue?vue&type=script&lang=js&"
import style0 from "./gysHome.vue?vue&type=style&index=0&id=adf53162&scoped=true&media=screen&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf53162",
  null
  
)

export default component.exports